import React, { useState, createContext } from "react"
import PropTypes from "prop-types"
import BurgerMenu from "./burger-menu"
import Header from "./Header"
import Footer from "./Footer"
import ContactModal from "./ContactModal"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

export const ContactUsContext = createContext({
  toggleModalVisibility: () => {},
})

const Layout = ({ children }) => {
  const [isModalVisible, setModalVisibility] = useState(false)
  const toggleModalVisibility = () => {
    setModalVisibility(!isModalVisible)
  }

  const contextValue = { toggleModalVisibility }

  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LeKndMUAAAAAAAjfTmkxDNiz8Mr2b7twevGgOBv">
      <meta charSet="utf-8" />
      <script src="https://unpkg.com/netlify-auth-providers" />

      <BurgerMenu toggleModalVisibility={toggleModalVisibility} />
      <Header toggleModalVisibility={toggleModalVisibility} />
      <ContactModal
        visible={isModalVisible}
        toggleVisibility={toggleModalVisibility}
        from={"Contact Modal"}
      />
      <ContactUsContext.Provider value={contextValue}>
        <main>{children}</main>
      </ContactUsContext.Provider>
      <Footer toggleModalVisibility={toggleModalVisibility} />
    </GoogleReCaptchaProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
